export const Uidmap:{ [key: string]: any } = {
  'UID:P_TINPERM-FE_1AA4816405600003': ['Common-confirm', 'Modal-confirm', 'Calendar-confirm'],
  'UID:P_TINPERM-FE_1AA63B4605600005': ['Common-cancel', 'Modal-cancel'],
  'UID:P_TINPERM-FE_1AA63B8E05C80000': 'Common-loading',
  'UID:P_TINPERM-FE_1AA63BEE05C80001': ['Common-close', 'ErrorMessage-close'],
  'UID:P_TINPERM-FE_1AA63C3205600006': ['CardBox-label', 'NavBar-title'],
  'UID:P_TINPERM-FE_1AA63CAC05C80006': 'CardBox-delete',
  'UID:P_TINPERM-FE_1AA63CD605C80001': 'CardBox-fold',
  'UID:P_TINPERM-FE_1AA63D5805600000': 'CardBox-more',
  'UID:P_TINPERM-FE_1AA63D8205600008': 'DateTimePicker-popTitle',
  'UID:P_TINPERM-FE_1AA63DAC05600003': ['DateTimePicker-placeholder', 'TimePicker-placeholder', 'Cascader-placeholder'],
  'UID:P_TINPERM-FE_1AA63DDC05C80009': ['DateTimePicker-clearAndReturn', 'TimePicker-clearAndReturn', 'TimeRangePicker-clearAndReturn'],
  'UID:P_TINPERM-FE_1AA63E0005C80009': 'DateTimePicker-week',
  'UID:P_TINPERM-FE_1AA63E2805600001': ['DateTimePicker-year', 'TimeRangePicker-year'],
  'UID:P_TINPERM-FE_1AA63E4A05600002': ['DateTimePicker-month', 'TimeRangePicker-month'],
  'UID:P_TINPERM-FE_1AA63F1805600001': ['DateTimePicker-day', 'TimeRangePicker-day'],
  'UID:P_TINPERM-FE_1AA63F4205600009': ['DateTimePicker-hour', 'TimeRangePicker-hour', 'TimePicker-hour'],
  'UID:P_TINPERM-FE_1AA63F7005C80004': ['DateTimePicker-minute', 'TimeRangePicker-minute', 'TimePicker-minute'],
  'UID:P_TINPERM-FE_1AA63F9205600006': ['DateTimePicker-second', 'TimePicker-second'],
  'UID:P_TINPERM-FE_1AA63FEA05C80003': 'Empty-noData',
  'UID:P_TINPERM-FE_1B8F2BBA05E00006': 'Empty-noCollect',
  'UID:P_TINPERM-FE_1B8F2BE404180008': 'Empty-noResult',
  'UID:P_TINPERM-FE_1AA6474805600007': ['FormItemWrapper-confirmText', 'Modal-ok', 'Dialog-ok'],
  'UID:P_TINPERM-FE_1AA6477205C80003': 'FormItemWrapper-errorText',
  'UID:P_TINPERM-FE_1AA6479C05C80005': 'Input-label',
  'UID:P_TINPERM-FE_1AA647DA05600003': 'Radio-selected',
  'UID:P_TINPERM-FE_1AA647FC05C80002': 'Radio-selectAll',
  'UID:P_TINPERM-FE_1AA6482205600006': 'Radio-data',
  'UID:P_TINPERM-FE_1AA6485005C80009': 'Search-placeholder',
  'UID:P_TINPERM-FE_1AA649F005600001': 'TimePicker-popTitle',
  'UID:P_TINPERM-FE_1AA64A6605600004': ['TimePicker-am', 'DatePicker-AM'],
  'UID:P_TINPERM-FE_1AA64A9205600003': ['TimePicker-pm', 'DatePicker-PM'],
  'UID:P_TINPERM-FE_1AA64F4605600009': 'TimeRangePicker-popTitle',
  'UID:P_TINPERM-FE_1AA64F9405600006': 'TimeRangePicker-placeholder',
  'UID:P_TINPERM-FE_1AA6541605600002': 'TimeRangePicker-to',
  'UID:P_TINPERM-FE_1AA6547C05C80006': 'Calendar-title',
  'UID:P_TINPERM-FE_1AA685FA05C80008': 'Calendar-start',
  'UID:P_TINPERM-FE_1AA6861805600006': 'Calendar-end',
  'UID:P_TINPERM-FE_1AA654A205600009': 'Calendar-today',
  'UID:P_TINPERM-FE_1AA6550C05C80003': 'Calendar-markItems',
  'UID:P_TINPERM-FE_1B86DBD204F00004': 'Calendar-months',
  'UID:P_TINPERM-FE_1AA6574605C80008': 'Mask-name',
  'UID:P_TINPERM-FE_1B0301C004280003': 'InfiniteScroll-noMore',
  'UID:P_TINPERM-FE_1B03020204280008': 'InfiniteScroll-failedToLoad',
  'UID:P_TINPERM-FE_1B03023004400001': 'InfiniteScroll-retry',
  'UID:P_TINPERM-FE_1B03027404280009': 'PullToRefresh-pulling',
  'UID:P_TINPERM-FE_1B0302A404400003': 'PullToRefresh-canRelease',
  'UID:P_TINPERM-FE_1B0302C804280006': 'PullToRefresh-complete',
  'UID:P_TINPERM-FE_1B7E9B9605200006': 'Radio-reset',
  'UID:P_TINPERM-FE_1B8F2C1E05E00005': 'ErrorBlock-default-title',
  'UID:P_TINPERM-FE_1B8F2C4005E00009': 'ErrorBlock-disconnected-title',
  'UID:P_TINPERM-FE_1B8F2C6205E00007': 'ErrorBlock-disconnected-description',
  'UID:P_TINPERM-FE_1B8F2C8604180006': 'ErrorBlock-failed-title',
  'UID:P_TINPERM-FE_1B8F2CA604180003': 'ErrorBlock-failed-description',
  'UID:P_TINPERM-FE_1B8F2CC405E00008': 'ErrorBlock-denied-title',
  'UID:P_TINPERM-FE_1B8F2CE605E00005': 'ErrorBlock-error-title',
  'UID:P_TINPERM-FE_1B8F2D0A05E00002': 'ErrorBlock-error-description',
  'UID:P_TINPERM-FE_1B7EA49A05480000': 'Form-required',
  'UID:P_TINPERM-FE_1B7EA4C405480007': 'Form-optional',
  'UID:P_TINPERM-FE_1B868DF204A00006': 'Form-defaultValidateMessages-default',
  'UID:P_TINPERM-FE_1B7EA53A05480001': 'Form-defaultValidateMessages-required',
  'UID:P_TINPERM-FE_1B7EA57605480006': 'Form-defaultValidateMessages-enum',
  'UID:P_TINPERM-FE_1B7EA59E05200003': 'Form-defaultValidateMessages-whitespace',
  'UID:P_TINPERM-FE_1B7EA6D005480008': 'Form-defaultValidateMessages-date-format',
  'UID:P_TINPERM-FE_1B7EA6F605480004': 'Form-defaultValidateMessages-date-parse',
  'UID:P_TINPERM-FE_1B7EA71805200009': 'Form-defaultValidateMessages-date-invalid',
  'UID:P_TINPERM-FE_1B7EA74205480001': ['Form-defaultValidateMessages-types-string', 'Form-defaultValidateMessages-types-method', 'Form-defaultValidateMessages-types-array', 'Form-defaultValidateMessages-types-object', 'Form-defaultValidateMessages-types-number', 'Form-defaultValidateMessages-types-date', 'Form-defaultValidateMessages-types-boolean', 'Form-defaultValidateMessages-types-integer', 'Form-defaultValidateMessages-types-float', 'Form-defaultValidateMessages-types-regexp', 'Form-defaultValidateMessages-types-email', 'Form-defaultValidateMessages-types-url', 'Form-defaultValidateMessages-types-hex'],
  'UID:P_TINPERM-FE_1B7EA76C05200004': 'Form-defaultValidateMessages-string-len',
  'UID:P_TINPERM-FE_1B7EA79605480008': 'Form-defaultValidateMessages-string-min',
  'UID:P_TINPERM-FE_1B7EA7CE05480004': 'Form-defaultValidateMessages-string-max',
  'UID:P_TINPERM-FE_1B7EA80E05200002': 'Form-defaultValidateMessages-string-range',
  'UID:P_TINPERM-FE_1B7EA83205480005': 'Form-defaultValidateMessages-number-len',
  'UID:P_TINPERM-FE_1B7EA85C05480007': 'Form-defaultValidateMessages-number-min',
  'UID:P_TINPERM-FE_1B7EA87E05200004': 'Form-defaultValidateMessages-number-max',
  'UID:P_TINPERM-FE_1B7EA8A605480000': 'Form-defaultValidateMessages-number-range',
  'UID:P_TINPERM-FE_1B7EA8CC05480009': 'Form-defaultValidateMessages-array-len',
  'UID:P_TINPERM-FE_1B7EA8EE05200005': 'Form-defaultValidateMessages-array-min',
  'UID:P_TINPERM-FE_1B7EA91405200000': 'Form-defaultValidateMessages-array-max',
  'UID:P_TINPERM-FE_1B7EA93805200002': 'Form-defaultValidateMessages-array-range',
  'UID:P_TINPERM-FE_1B868DA204A00001': 'Form-defaultValidateMessages-pattern-mismatch',
  'UID:P_TINPERM-FE_1BA1935405380007': 'InputNumber-hundred',
  'UID:P_TINPERM-FE_1BA1937E05380008': 'InputNumber-thousand',
  'UID:P_TINPERM-FE_1BA193A805200000': 'InputNumber-tenThousand',
  'UID:P_TINPERM-FE_1BA198A805380005': 'InputNumber-hundredThousand',
  'UID:P_TINPERM-FE_1BA193F005200007': 'InputNumber-million',
  'UID:P_TINPERM-FE_1BA198CE05380001': 'InputNumber-tenMillion',
  'UID:P_TINPERM-FE_1BA1942E05380002': 'InputNumber-hundredMillion',
  'UID:P_TINPERM-FE_1BA1947005200004': 'InputNumber-billion',
  'UID:P_TINPERM-FE_1BA1948E05380000': 'InputNumber-tenBillion',
  'UID:P_TINPERM-FE_1BA198F205380002': 'InputNumber-hundredBillion',
  'UID:P_TINPERM-FE_1BA194D605200008': 'InputNumber-trillionsAndAbove',
  'UID:P_TINPERM-FE_1C74265405800009': 'InputNumber-trillion',
  'UID:P_TINPERM-FE_1C74268C04680008': 'InputNumber-tenTrillion',
  'UID:P_TINPERM-FE_1C7426B004680004': 'InputNumber-hundredTrillion',
  'UID:P_TINPERM-FE_1C7426D005800006': 'InputNumber-quadrillion',
  'UID:P_TINPERM-FE_1BA6B42C04300003': 'Switch-name',
  'UID:P_TINPERM-FE_1C179E5404800005': 'ImageUploader-upload',
  'UID:P_TINPERM-FE_1C819B9A04800007': 'Tag-start',
  'UID:P_TINPERM-FE_1C819BCE04800005': 'Tag-info',
  'UID:P_TINPERM-FE_1C819BF404080003': 'Tag-success',
  'UID:P_TINPERM-FE_1C819C5204800002': 'Tag-warning',
  'UID:P_TINPERM-FE_1C819C8E04800002': 'Tag-danger',
  'UID:P_TINPERM-FE_1C819D220480004B': 'Tag-invalid',
  'UID:P_TINPERM-FE_1CBE8CEA04480001': 'ErrorMessage-exceptionDetails',
  'UID:P_TINPERM-FE_1CBE8D2004B80000': 'ErrorMessage-escalation',
  'UID:P_TINPERM-FE_1CBE8F8404B80009': 'ErrorMessage-replicatingSuccess',
  'UID:P_TINPERM-FE_1CBE8FAC04480002': 'ErrorMessage-copy',
  'UID:P_TINPERM-FE_1CBE8FE404480001': 'ErrorMessage-status',
  'UID:P_TINPERM-FE_1CBE900604B80004': 'ErrorMessage-linkID',
  'UID:P_TINPERM-FE_1E8BF43405200004': 'Avatar-maxText'
}
